import { Component, inject, Injector, OnInit, ViewEncapsulation } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationStart, Router, RouterOutlet } from '@angular/router';
import { AppInitAuthManagerService, ImpersonationBannerComponent } from '@meddev/fe-shared';
import { Store } from '@ngxs/store';
import _ from 'lodash';
import { ScriptLoaderService } from './_services/script-loader.service';
import { AppModulesType } from './_shared/enums/appModulesType.enum';
import { HelperService, MfToastService, RulesService, StorageService } from './_shared/services';
import { ActiveModulesService } from './_shared/services/activeModules.service';
import { WebsocketActions } from './_shared/state/websocket/websocket.actions';
import { Helpers } from './helpers';
import { QuickSidebarComponent } from './theme/layouts/quick-sidebar/quick-sidebar.component';
import { TelemedicineComponent } from './theme/pages/telemedicine/telemedicine/telemedicine.component';

@Component({
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'body',
    templateUrl: './app.component.html',
    encapsulation: ViewEncapsulation.None,
    imports: [RouterOutlet, QuickSidebarComponent, TelemedicineComponent, ImpersonationBannerComponent],
})
export class AppComponent implements OnInit {
    private _router = inject(Router);
    toastr = inject(MfToastService);
    private rules = inject(RulesService);
    private helper = inject(HelperService);
    private injector = inject(Injector);
    private storage = inject(StorageService);
    private store = inject(Store);
    private activeModules = inject(ActiveModulesService);
    private _script = inject(ScriptLoaderService);

    private globalBodyClassBase =
        'm-page--loading-non-block m-page--fluid m--skin- m-content--skin-light2 m-header--fixed m-header--fixed-mobile m-aside-left--enabled m-aside-left--skin-dark m-aside-left--fixed m-aside-left--offcanvas m-aside--offcanvas-default m-topbar--on';
    private globalBodyClass = '';

    constructor() {
        this.toggleMenu();
    }

    ngOnInit() {
        this._script.loadScripts('body', ['assets/vendors/base/vendors.bundle.js', 'assets/demo/demo5/base/scripts.bundle.js'], true).then(() => {
            Helpers.setLoading(false);
        });
        this.toggleMenu();
        this._router.events.subscribe(route => {
            this.toggleMenu();

            if (route instanceof NavigationStart) {
                const curRoute = route.url?.split('/')[1];
                const isNotPublic = curRoute !== 'public';
                if (this.helper.isDifferentAppVersion()) {
                    const appInitAuthManager = this.injector.get(AppInitAuthManagerService);
                    if (isNotPublic) {
                        this.toastr.info('Naložene so bile posodobitve. Potrebna je ponovna prijava.');
                        appInitAuthManager.performLogout(true, true);
                    } else {
                        appInitAuthManager.performLogout(true, false);
                        window.location.reload();
                    }
                }
                Helpers.setLoading(true);
                Helpers.bodyClass(this.globalBodyClass);
            }
            if (route instanceof NavigationCancel) {
                Helpers.setLoading(false);
            }

            if (route instanceof NavigationEnd) {
                Helpers.setLoading(false);
            }
        });

        this.rules.setRules();

        if (
            [AppModulesType.TELEMEDICINE, AppModulesType.WIDGETS, AppModulesType.CASE, AppModulesType.SURVEYS].some(module =>
                this.activeModules.isAM(module),
            )
        ) {
            this.store.dispatch(new WebsocketActions.InitWebSocket());
        }
    }

    private toggleMenu(): void {
        if (_.get(this.storage.getGuiUserSettings(), 'app.isMenuMinimized', false)) {
            this.globalBodyClass = this.globalBodyClassBase + ' m-brand--minimize m-aside-left--minimize';
        } else {
            this.globalBodyClass = this.globalBodyClassBase;
        }
    }
}
